import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Injectable({
    providedIn:"root"
})
export class SpinnerService
{
    private spinnerSource : Subject<boolean> = new Subject<boolean>();
    spinner$ : Observable<boolean> = this.spinnerSource.asObservable();

    showSpinner()
    {    
            this.spinnerSource.next(true);
      
    }
    hideSpinner()
    {
            this.spinnerSource.next(false);
        
    }
}